import React from 'react'

export const Loader = () => {
    return (
        <div className="loader n-flat">
            <img className="of-hidden w-full" src={process.env.PUBLIC_URL + '/images/personal/profile.png'} alt="mytabworks"/>
        </div>
    )
}
